export interface InternationalTopUpRequestDto {
    internationalPhoneNumber: string;
    operatorId: string | null;
}
